import angular from 'angular';

angular.module('cxRelations').directive('relReadEid', function() {
  return {
    restrict: 'E',
    template: require('./relReadEid.html'),
    scope: {
      relation: '=',
    },
    controllerAs: 'vm',
    bindToController: true,
    controller: [
      'ModalService',
      'checkEidConfiguration',
      function(ModalService, checkEidConfiguration) {
        var vm = this;

        vm.hasEidFeature = checkEidConfiguration();

        vm.openEidDialog = function() {
          ModalService.showModal({
            template: require('../dialogs/readEidDialog.html'),
            controller: 'ReadEidDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              relationId: vm.relation.id,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        };
      },
    ],
  };
});
